import React from "react";
import Button from "../../../components/Form/Button";
import { IYear } from "../../../services/api/Year";
import Form from "../components/Form";

import ItemBox from "../../../components/ItemBox";

interface YearListProps {
  years: IYear[];
}

const YearList: React.FC<YearListProps> = ({ years }) => {
  // function DisplayEdit(obj: HTMLFormElement, e: any) {
  // }

  function toggleForm(e: any) {
    e.target.parentNode.nextElementSibling.classList.toggle("form--open");
  }

  function renderRow(year: IYear) {
    return (
      <li key={year.id}>
        <ItemBox name={year.name}>
          <Button className="box__edit" title="Edit" onClick={toggleForm} />
        </ItemBox>
        <div className="groups__form--edit">
          <Form year={year} />
        </div>
      </li>
    );
  }

  return (
    <React.Fragment>
      <ul className="groups__list groups__list--main">
        {years.map(renderRow)}
      </ul>
    </React.Fragment>
  );
};

export default YearList;
